import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import BackButton from '../../../components/BackButton';
import SheetTitle from '../../../components/SheetTitle';
import c from '../Help.less';

export default function () {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/buy-music" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="How do I buy music" />
      <p>
        In order to buy tracks, you need to have money on your balance.<br />
        Your current <strong>balance</strong> is shown in the header, in the top right corner,
        under your <strong>username</strong>.
      </p>
      <p>
        Balance has no expiration date and can be used for buying tracks or albums whenever you want.
      </p>
      <p>
        In order to top up your balance, please click on <strong>your username</strong> and then
        {' '}<Link to="/shop/top-up">Top Up</Link>.<br />
        All the prices and payments are in USD.<br />
        If you use a different currency, it will be transferred to USD.
      </p>
      <p>
        In order to buy a track, please click on the <strong>blue button with a price and a shopping cart icon</strong>.
        This action adds the track to your shopping cart.
      </p>
      <p>
        If you want to buy the whole album, please click on the blue button and the shopping cart icon next to the album
        name. This action adds the whole album to your shopping cart.
      </p>
      <p>
        In order <strong>to undo the action</strong>, please just deselect the track/album by clicking the button once
        more.
      </p>
      <p>
        Then, please go to your <strong>shopping cart</strong>, in the header, next to your username.
        In your shopping cart you can check out the tracks/albums. Now they are purchased and ready
        to be downloaded at any time.
      </p>
      <p>
        For your convenience, the system is wired not to sell anything twice to the same customer.
        Thus, <strong>it is technically impossible to be charged for the same track or album twice.</strong>
      </p>
      <HelpContactUs subject={2} />
    </div>
  );
}
